module.exports = __webpack_public_path__ + "img/live_big_icon.fc63464b.png";